import {
    ASSET_SUB_TYPE_MOTORHOME,
    ASSET_SUB_TYPE_CAMPERVAN,
    ASSET_SUB_TYPE_CARAVAN,
    ASSET_SUB_TYPE_OTHER_CAMPER,
} from '~/config/assetTypes';

// https://go.equals.com/workbooks/1122af85-53ed-4cf5-9531-9810a9b8ca9c#2
// @note keep values in desc order, percentages sum up to 100
export const BOOKING_FEE_PERCENTAGE_SPLIT = {
    CH: {
        earnings: 63,
        service: 22,
        insurance: 13,
        vat: 2,
    },
    DK: {
        earnings: 66,
        service: 20,
        insurance: 9,
        vat: 5,
    },
    FI: {
        earnings: 67,
        service: 20,
        insurance: 8,
        vat: 5,
    },
    DE: {
        earnings: 77.5,
        service: 10,
        insurance: 10.6,
        vat: 1.9,
    },
    AT: {
        earnings: 77.4,
        service: 10,
        insurance: 10.6,
        vat: 2,
    },
    NO: {
        earnings: 66,
        service: 21,
        insurance: 8,
        vat: 5,
    },
    SE: {
        earnings: 62,
        service: 21,
        insurance: 11,
        vat: 5,
    },
};

// @note stored in cents
export const TYPICAL_DEPOSIT_AMOUNTS = {
    CH: {
        [ASSET_SUB_TYPE_MOTORHOME]: 100000,
        [ASSET_SUB_TYPE_CARAVAN]: 50000,
        [ASSET_SUB_TYPE_CAMPERVAN]: 50000,
        [ASSET_SUB_TYPE_OTHER_CAMPER]: 50000,
    },
    DK: {
        [ASSET_SUB_TYPE_MOTORHOME]: 300000,
        [ASSET_SUB_TYPE_CARAVAN]: 300000,
        [ASSET_SUB_TYPE_CAMPERVAN]: 300000,
        [ASSET_SUB_TYPE_OTHER_CAMPER]: 300000,
    },
    FI: {
        [ASSET_SUB_TYPE_MOTORHOME]: 50000,
        [ASSET_SUB_TYPE_CARAVAN]: 50000,
        [ASSET_SUB_TYPE_CAMPERVAN]: 50000,
        [ASSET_SUB_TYPE_OTHER_CAMPER]: 50000,
    },
    DE: {
        [ASSET_SUB_TYPE_MOTORHOME]: 50000,
        [ASSET_SUB_TYPE_CARAVAN]: 50000,
        [ASSET_SUB_TYPE_CAMPERVAN]: 50000,
        [ASSET_SUB_TYPE_OTHER_CAMPER]: 50000,
    },
    AT: {
        [ASSET_SUB_TYPE_MOTORHOME]: 50000,
        [ASSET_SUB_TYPE_CARAVAN]: 50000,
        [ASSET_SUB_TYPE_CAMPERVAN]: 50000,
        [ASSET_SUB_TYPE_OTHER_CAMPER]: 50000,
    },
    NO: {
        [ASSET_SUB_TYPE_MOTORHOME]: 500000,
        [ASSET_SUB_TYPE_CARAVAN]: 500000,
        [ASSET_SUB_TYPE_CAMPERVAN]: 500000,
        [ASSET_SUB_TYPE_OTHER_CAMPER]: 500000,
    },
    SE: {
        [ASSET_SUB_TYPE_MOTORHOME]: 500000,
        [ASSET_SUB_TYPE_CARAVAN]: 500000,
        [ASSET_SUB_TYPE_CAMPERVAN]: 500000,
        [ASSET_SUB_TYPE_OTHER_CAMPER]: 500000,
    },
};

// @note stored in cents
export const TYPICAL_PRICE_PER_KM = {
    CH: 50,
    DK: 200,
    FI: 30,
    DE: 38,
    AT: 40,
    NO: 300,
    SE: 200,
};

// @note stored in cents
export const MAX_PRICE_PER_KM = {
    CH: 80,
    DK: 600,
    FI: 80,
    DE: 80,
    AT: 80,
    NO: 800,
    SE: 800,
};

export const MIN_NIGHTLY_EARNINGS_TENTHS = 14;
export const MIN_NIGHTLY_EARNINGS_HUNDRETHS = 140;

export const MIN_INCLUDED_KILOMETERS_PER_DAY = 140;
export const UNLIMITED_KILOMETERS = -1;
export const DEFAULT_LIMITED_KILOMETERS = 200;
